import { render, staticRenderFns } from "./spotcoins.vue?vue&type=template&id=007dc642&"
import script from "./spotcoins.vue?vue&type=script&lang=ts&"
export * from "./spotcoins.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports